import { ChangeDetectorRef, Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DropDownService } from '../../../service/drop-down.service';
import { AnalysisDetails, DropDown, SearchResult, Templates, AnalysisDetailsSLR } from '../../../model/analysis-details.model';
import { TemplateService } from '../../../service/template.service';
import { SharedService } from '../../../layouts/shared-service';
import { EventListenerFocusTrapInertStrategy } from '@angular/cdk/a11y';
import { UploadService } from '../../../service/upload.service';
import { StorageService } from '../../../service/storage.service';
import { DatePipe } from '@angular/common';
import { SlowBuffer } from 'buffer';

@Component({
  selector: 'app-small-large-report',
  templateUrl: './small-large-report.component.html',
  styleUrls: ['./small-large-report.component.scss']
})
export class SmallLargeReportComponent implements OnChanges {

  @Input() analysistype: string;
  @Input() editvalues: any;
  @Output() formvalue = new EventEmitter<any>();
  pageTitle = 'Analyze Report/Data';

  analysisFormGroup: FormGroup;
  maxDate;
  // lts80_dialog: FormControl = new FormControl();
  analysisDetails: AnalysisDetails;
  subtype: AnalysisDetails;
  tableNamesList: any[];
  tableNames: any;
  showTable = false;
  countTable = false;
  post: any;
  tableParamValue = [];
  GenTablesList = [];
  ValTablesList = [];
  SumTablesList = [];
  Smparameterlist = [];
  NewSmparameterlist = [];
  Lmparameterlist = [];
  NewLmparameterlist = [];
  selectedValTables = [];
  selectedAssayTables = [];
  selectedGeneralTables = [];
  decimalNumberPattern = '^[0-9]+(\.[0-9]+)?$';
  disabledValue
  tempdataerror;
  tempdataerrorvalue: boolean = false;
  duplicateFields = [
    'projectCode', 'lloq', 'uloq', 'regressionModel', 'freeze_thaw_dialog',
    'lts80_dialog', 'extraction_dialog', 'benchtop_dialog', 'sampleMatrix',
    'antiCoagulant', 'species', 'samplePrep', 'sampleDate', 'thresholdLayout'
  ];
  private removedFields: { [key: string]: any } = {};


  constructor(
    private formBuilder: FormBuilder,
    private _sharedService: SharedService,
    private uploadService: UploadService,
    private dropDownService: DropDownService,
    private templateService: TemplateService,
    private storageService: StorageService,
    private datePipe: DatePipe,
    private ref: ChangeDetectorRef
  ) {

    this._sharedService.emitChange(this.pageTitle);
    uploadService.disabledValue.subscribe(res => {
      this.disabledValue = res;

    })

  }

  ngOnInit() {
    this.createForm();
    this.getData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('analysistype' in changes) {
      if (changes.analysistype.currentValue) {
        this.analysistype = changes.analysistype.currentValue;
        this.Smparameterlist = [];
        this.Lmparameterlist = [];
      }
    }
  }

  ngAfterViewInit(): void {
    this.ref.detectChanges();
  }
  createForm() {
    let SLRvalue: AnalysisDetailsSLR | null = new AnalysisDetailsSLR();
    let analyteNamesDiffArray = null;
    let analyteNameArray = null;
    // if the editvaues are there it means we are editing 
    if (this.editvalues != undefined) {
      analyteNamesDiffArray = this.formBuilder.array<FormGroup>([]);
      analyteNameArray = this.formBuilder.array<FormGroup>([]);
      SLRvalue.analysisType = this.analysistype;
      SLRvalue.analysisSubtype = this.editvalues.analysisSubtype;
      SLRvalue.uploadedDocumentFormat = this.editvalues.uploadedDocumentFormat;
      SLRvalue.projectCode = this.editvalues.projectCode;
      SLRvalue.regressionModel = this.editvalues.regressionModel;
      SLRvalue.lloq = this.editvalues.lloq;
      SLRvalue.uloq = this.editvalues.uloq;
      SLRvalue.re_type = this.editvalues.re_type;
      SLRvalue.re_value = this.editvalues.re_value;
      SLRvalue.lts80_dialog = this.editvalues.lts80_dialog;
      SLRvalue.extraction_dialog = this.editvalues.extraction_dialog;
      SLRvalue.benchtop_dialog = this.editvalues.benchtop_dialog;
      SLRvalue.freeze_thaw_dialog = this.editvalues.freeze_thaw_dialog;
      SLRvalue.multipleAnalytes = this.editvalues.multipleAnalytes;
      SLRvalue.multipleAnalytesInfo = this.editvalues.multipleAnalytesInfo;
      SLRvalue.first_patient_dialog = this.editvalues.first_patient_dialog;
      SLRvalue.sampleMatrix = this.editvalues.sampleMatrix;
      SLRvalue.antiCoagulant = this.editvalues.antiCoagulant;
      SLRvalue.species = this.editvalues.species;
      SLRvalue.samplePrep = this.editvalues.samplePrep;
      SLRvalue.sampleDate = this.editvalues.sampleDate;
      SLRvalue.analyteNames = this.editvalues.analyteNames;
      SLRvalue.tableParamValue = this.editvalues.tableParamValue;
      SLRvalue.file_path = this.editvalues.file_path;
      SLRvalue.files = this.editvalues.files;
      SLRvalue.analyteName = this.editvalues.analyteName;
      SLRvalue.thresholdLayout = this.editvalues.thresholdLayout;
      this.editvalues.analyteNamesDiff.forEach((analyte, analyteIndex) => {
        analyteNamesDiffArray.push(this.addAnalyteRowsWithDetails(analyte));
      })
      this.editvalues.analyteNames.forEach((anName, index) => {
        analyteNameArray.push(this.addAnalyteRows(anName.analyteName));
      }) 
    }

    this.analysisFormGroup = this.formBuilder.group({
      analysisType: [SLRvalue?.analysisType ?? this.analysistype],
      analysisSubtype: [SLRvalue?.analysisSubtype ?? null],
      lloq: [SLRvalue?.lloq ?? null, [Validators.pattern(this.decimalNumberPattern)]],
      uloq: [SLRvalue?.uloq ?? null, [Validators.pattern(this.decimalNumberPattern)]],
      re_type: [SLRvalue?.re_type ?? true],
      re_value: [SLRvalue?.re_value ?? null],
      uploadedDocumentFormat: [SLRvalue?.uploadedDocumentFormat ?? null],
      multipleAnalytes: [SLRvalue?.multipleAnalytes ?? 'False'],
      multipleAnalytesInfo: [SLRvalue?.multipleAnalytesInfo ?? 'True'],
      first_patient_dialog: [SLRvalue?.first_patient_dialog ?? null],
      analyteNames: analyteNameArray == null ? this.formBuilder.array([this.addAnalyteRows()]) : analyteNameArray,
      analyteNamesDiff: analyteNamesDiffArray == null ? this.formBuilder.array([this.addAnalyteRowsWithDetails()]) : analyteNamesDiffArray,
      tableParamValue: [SLRvalue?.tableParamValue ?? null],
      files: [SLRvalue?.files ?? null],
      file_path: [SLRvalue?.file_path ?? null],
      projectCode: [SLRvalue?.projectCode ?? ''],
      regressionModel: [SLRvalue?.regressionModel ?? null],
      freeze_thaw_dialog: [SLRvalue?.freeze_thaw_dialog ?? null, [Validators.pattern(this.decimalNumberPattern)]],
      lts80_dialog: [SLRvalue?.lts80_dialog ?? null, [Validators.pattern(this.decimalNumberPattern)]],
      extraction_dialog: [SLRvalue?.extraction_dialog ?? null, [Validators.pattern(this.decimalNumberPattern)]],
      benchtop_dialog: [SLRvalue?.benchtop_dialog??null, [Validators.pattern(this.decimalNumberPattern)]],
      sampleMatrix: [SLRvalue?.sampleMatrix??'', [Validators.pattern('^[a-zA-Z ]*$')]],
      antiCoagulant: [SLRvalue?.antiCoagulant??'', [Validators.pattern('^[A-Za-z0-9? ,_-]+$')]],
      species: [SLRvalue?.species??'', [Validators.pattern('^[a-zA-Z ]*$')]],
      samplePrep: [SLRvalue?.samplePrep??null],
      sampleDate: [SLRvalue?.sampleDate??'', [Validators.max(this.maxDate)]],
      thresholdLayout: [SLRvalue?.thresholdLayout??'False'],
    });
    this.handleMultipleAnalytesInfoChange();
  }


  get formControls() {
    return this.analysisFormGroup.controls;
  }

  formatDateForSending(date: Date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd') || '';
  }

  handleMultipleAnalytesInfoChange() {
    // Watch for changes in `multipleAnalytesInfo`
    this.analysisFormGroup.get('multipleAnalytesInfo')?.valueChanges.subscribe(value => {
      const analyteNamesDiff = this.analysisFormGroup.get('analyteNamesDiff') as FormArray;
      analyteNamesDiff.clear()
      if (value === 'False') {
        this.removeDuplicateFieldsFromForm();
        (this.analysisFormGroup.get('analyteNames') as FormArray).controls.forEach(() => {
          analyteNamesDiff.push(this.addAnalyteRowsWithDetails());
        });
      }
      else if (value === 'True') {
        this.restoreDuplicateFieldsToForm();
      }
    });
  }

  removeDuplicateFieldsFromForm() {
    this.duplicateFields.forEach(field => {
      if (this.analysisFormGroup.contains(field)) {
        this.removedFields[field] = this.analysisFormGroup.get(field)?.value;
        this.analysisFormGroup.removeControl(field);
      }
    });
  }

  restoreDuplicateFieldsToForm() {
    this.duplicateFields.forEach(field => {
      if (!this.analysisFormGroup.contains(field)) {
        this.analysisFormGroup.addControl(field, new FormControl(this.removedFields[field] || null));
      }
    });
    this.removedFields = {};
  }

  addAnalyteRows(name?) {
    return this.formBuilder.group({
      analyteName: [name??'', [Validators.pattern('^[A-Za-z\x270-9 .,-]+$')]],
      LLOQValue: ['', [Validators.pattern(this.decimalNumberPattern)]],
      ULOQValue: ['', [Validators.pattern(this.decimalNumberPattern)]],
    })
  }

  addAnalyteRowsWithDetails(analyteinfo?: any) {

    let parameterList = this.analysistype === 'SMR' ? this.Smparameterlist : this.Lmparameterlist;
    parameterList = analyteinfo?.tableParamValue ?? parameterList
    const parameterFormArray = this.formBuilder.array(
      parameterList.map(param => this.formBuilder.group({
        parameter_label: [param.parameter_label],
        parameter_value: [param.parameter_value, Validators.required],
        analysis_type: [param.analysis_type]
      }))
    );
    return this.formBuilder.group({
      projectCode: [analyteinfo?.projectCode ?? ''],
      lloq: [analyteinfo?.lloq ?? null, [Validators.pattern(this.decimalNumberPattern)]],
      uloq: [analyteinfo?.uloq ?? null, [Validators.pattern(this.decimalNumberPattern)]],
      multipleAnalytes: [analyteinfo?.multipleAnalytes ?? 'False'],
      regressionModel: [analyteinfo?.regressionModel ?? null],
      freeze_thaw_dialog: [analyteinfo?.freeze_thaw_dialog ?? null, [Validators.pattern(this.decimalNumberPattern)]],
      lts80_dialog: [analyteinfo?.lts80_dialog ?? null, [Validators.pattern(this.decimalNumberPattern)]],
      extraction_dialog: [analyteinfo?.extraction_dialog ?? null, [Validators.pattern(this.decimalNumberPattern)]],
      benchtop_dialog: [analyteinfo?.benchtop_dialog ?? null, [Validators.pattern(this.decimalNumberPattern)]],
      sampleMatrix: [analyteinfo?.sampleMatrix ?? '', [Validators.pattern('^[a-zA-Z ]*$')]],
      antiCoagulant: [analyteinfo?.antiCoagulant ?? '', [Validators.pattern('^[A-Za-z0-9? ,_-]+$')]],
      species: [analyteinfo?.species ?? '', [Validators.pattern('^[a-zA-Z ]*$')]],
      samplePrep: [analyteinfo?.samplePrep ?? null],
      sampleDate: [analyteinfo?.sampleDate ?? '',[Validators.max(this.maxDate)]],
      thresholdLayout: [analyteinfo?.thresholdLayout ?? 'False'],
      tableParamValue: parameterFormArray
    });
  }

  // TODO - Test with multiple analyte 
  //  Copy the LLOQ/ULOQ the user already entered (global field in "Same" mode, or the
  // per-analyte analyteNamesDiff panel in "Different" mode) onto each analyteNames entry,
  // so the submitted payload carries LLOQValue/ULOQValue
  populateAnalyteLloqUloq() {
    const sameInfo = this.analysisFormGroup.get('multipleAnalytesInfo')?.value === 'True';
    this.analyteNames.controls.forEach((ctrl, i) => {
      let lloqVal;
      let uloqVal;
      if (sameInfo) {
        lloqVal = this.analysisFormGroup.get('lloq')?.value;
        uloqVal = this.analysisFormGroup.get('uloq')?.value;
      } else {
        const diff = this.analyteNamesDiff.at(i);
        lloqVal = diff?.get('lloq')?.value;
        uloqVal = diff?.get('uloq')?.value;
      }
      ctrl.get('LLOQValue')?.setValue(lloqVal ?? '');
      ctrl.get('ULOQValue')?.setValue(uloqVal ?? '');
    });
  }

  onSubmit(post: any) {
    const formattedDate = this.formatDateForSending(this.analysisFormGroup.controls?.sampleDate?.value);
    this.populateAnalyteLloqUloq();
    this.analysisDetails = Object.assign({}, this.analysisFormGroup.value);
    this.analysisDetails.sampleDate = formattedDate
    this.analysisDetails.userId = this.storageService.get('username');
    this.analysisDetails.analysisId = (new Date).getTime().toString();
    this.analysisDetails.analyteName = this.analyteNames.value.map(res =>
      res = res.analyteName);
    this.post = post;

    if (this.analysisDetails.multipleAnalytesInfo == 'True') {
      if (this.tableNames?.[0]?.parameter.parameter_value !== this.tableParamValue) {

        if (this.analysistype == 'SMR') {
          if (this.tableParamValue = []) {
            this.analysisDetails.tableParamValue = this.Smparameterlist;
          }
          else {
            this.analysisDetails.tableParamValue = this.NewSmparameterlist;
          }

        }
        else {
          if (this.tableParamValue = []) {
            this.analysisDetails.tableParamValue = this.Lmparameterlist;
          }
          else {
            this.analysisDetails.tableParamValue = this.Lmparameterlist;
          }
        }


      }
    }

    console.log(this.analysisDetails)
    this.formvalue.emit(this.analysisDetails);
  }




  getData() {

    if (this.editvalues !== undefined) {
      this.templateService.getTableData().subscribe((table_names: []) => {
        try {
          this.tableNames = table_names;
          this.tableNames = Object.entries(this.tableNames).map((e) => ({ [e[0]]: e[1] })) ?? [];
          this.tableNames[0]?.parameter.forEach((res, index) => {
            if (res.analysis_type == 'SMR') {
              this.Smparameterlist.push(this.tableNames[0].parameter[index]);
              this.Smallvaluechanges(this.editvalues.tableParamValue);
            }
            else {
              this.Lmparameterlist.push(this.tableNames[0].parameter[index]);
              this.Largevaluechanges(this.editvalues.tableParamValue);
            }
          })
          this.tableNames[1]?.table_data.forEach((res, index) => {
            if (res.table_type == 'gen') {
              this.GenTablesList.push(this.tableNames[1].table_data[index]);
            }
            else if (res.table_type == 'mv') {
              this.ValTablesList.push(this.tableNames[1].table_data[index]);
            }
            else if (res.table_type == 'sa') {
              this.SumTablesList.push(this.tableNames[1].table_data[index]);
            }
          })
          this.GenTablesList = [...[{ table_name: 'Select All', table_type: 'Select All', checked: false }], ...this.GenTablesList];
          this.ValTablesList = [...[{ table_name: 'Select All', table_type: 'Select All', checked: false }], ...this.ValTablesList];
          this.SumTablesList = [...[{ table_name: 'Select All', table_type: 'Select All', checked: false }], ...this.SumTablesList];

        }
        catch (error) {
          console.log(error);
        }

      },
        error => {
          console.log(error)
          this.tempdataerrorvalue = true;
          this.tempdataerror = 'Internal Servor error, Cannot get threshold values.Please refresh the page';
          console.log(this.tempdataerror, this.tempdataerrorvalue)
        }
      );
    }
    else {
      const analysis_subtype = this.analysisFormGroup.value?.analysisSubtype;
      this.templateService.getTableData().subscribe((table_names: any) => {
        try {
          console.log(table_names)
          this.tableNames = table_names;
          this.tableNames = Object.entries(this.tableNames).map((e) => ({ [e[0]]: e[1] }));

          this.tableNames[0]?.parameter.forEach((res, index) => {
            if (res.analysis_type == 'SMR') {
              this.Smparameterlist.push(this.tableNames[0].parameter[index])

            }
            else {
              this.Lmparameterlist.push(this.tableNames[0].parameter[index])

            }
          })


          this.tableNames[1]?.table_data.forEach((res, index) => {
            if (res.table_type == 'gen') {
              this.GenTablesList.push(this.tableNames[1].table_data[index]);

            }
            else if (res.table_type == 'mv') {
              this.ValTablesList.push(this.tableNames[1].table_data[index]);

            }
            else if (res.table_type == 'sa') {
              this.SumTablesList.push(this.tableNames[1].table_data[index]);
            }
          })
          this.GenTablesList = [...[{ table_name: 'Select All', table_type: 'Select All', checked: false }], ...this.GenTablesList];
          this.ValTablesList = [...[{ table_name: 'Select All', table_type: 'Select All', checked: false }], ...this.ValTablesList];
          this.SumTablesList = [...[{ table_name: 'Select All', table_type: 'Select All', checked: false }], ...this.SumTablesList];


        }
        catch (error) {
          console.log(error);
        }
      },
        error => {
          console.log(error)
          this.tempdataerrorvalue = true;
          this.tempdataerror = 'Internal Servor error, Cannot get threshold values.Please refresh the page';
          console.log(this.tempdataerror, this.tempdataerrorvalue)
        });

    }
  }

  Smallvaluechange(event, analyteIndex: number) {
    this.tableParamValue = []
    this.tableParamValue = event?.target?.value;
    this.Smparameterlist[analyteIndex].parameter_value = this.tableParamValue;
    const result = this.Smparameterlist.map(({ analysis_type, parameter_label, ...data }) => ({ ...data }));
    this.NewSmparameterlist = result;
    console.log(this.NewSmparameterlist)
  }

  Smallvaluechanges(event) {
    if (this.editvalues.multipleAnalytesInfo === 'True') {
      for (let i = 0; i < this.Smparameterlist.length; i++) {
        this.Smparameterlist[i].parameter_value = this.editvalues?.tableParamValue[i]?.parameter_value;
      }
    }
  }


  Largevaluechanges(event) {
    if (this.editvalues.multipleAnalytesInfo === 'True') {
      for (let i = 0; i < this.Lmparameterlist.length; i++) {
        this.Lmparameterlist[i].parameter_value = this.editvalues?.tableParamValue[i]?.parameter_value;
      }
    }
  }

  Largevaluechange(event, analyteIndex: number) {
    this.tableParamValue = []
    this.tableParamValue = event?.target?.value;
    this.Lmparameterlist[analyteIndex].parameter_value = this.tableParamValue;
    const result = this.Lmparameterlist.map(({ analysis_type, parameter_label, ...data }) => ({ ...data }));
    this.NewLmparameterlist = result;

  }


  onParameterChange(event: any, analyteIndex: number, paramIndex: number) {
    const newValue = event.target.value;
    const analyte = (this.analysisFormGroup.get('analyteNamesDiff') as FormArray).at(analyteIndex) as FormGroup;
    const parameters = analyte.get('tableParamValue') as FormArray;
    const parameter = parameters.at(paramIndex) as FormGroup;

    // Optionally, you can perform validations or other logic here
    console.log(`Analyte ${analyteIndex + 1}, Parameter ${paramIndex + 1} updated to:`, newValue);

    // If you need to update separate lists like NewSmparameterlist or NewLmparameterlist:
    if (parameter.get('analysis_type')?.value === 'SMR') {
      this.NewSmparameterlist = parameters.controls.map(ctrl => ({
        parameter_label: ctrl.get('parameter_label')?.value,
        parameter_value: ctrl.get('parameter_value')?.value,
        analysis_type: ctrl.get('analysis_type')?.value
      }));
      console.log(this.NewSmparameterlist);
    } else if (parameter.get('analysis_type')?.value === 'LMR') {
      this.NewLmparameterlist = parameters.controls.map(ctrl => ({
        parameter_label: ctrl.get('parameter_label')?.value,
        parameter_value: ctrl.get('parameter_value')?.value,
        analysis_type: ctrl.get('analysis_type')?.value
      }));
      console.log(this.NewLmparameterlist);
    }
  }






  getDropDownValues(key) {
    return this.dropDownService.dropDownsMap.get(key);
  }

  get analyteNames() {
    return this.analysisFormGroup.get('analyteNames') as FormArray;
  }

  get analyteNamesDiff() {
    return this.analysisFormGroup.get('analyteNamesDiff') as FormArray;
  }

  addAnalyte() {
    this.analyteNames.push(this.addAnalyteRows());
    if (this.analysisFormGroup.get('multipleAnalytes').value === 'True' &&
      this.analysisFormGroup.get('multipleAnalytesInfo').value === 'False') {
      const analyteNamesDiff = this.analysisFormGroup.get('analyteNamesDiff') as FormArray;
      analyteNamesDiff.push(this.addAnalyteRowsWithDetails());
    }

  }

  removeAnalyte(index) {
    this.analyteNames.removeAt(index);
    if (this.analysisFormGroup.get('multipleAnalytesInfo').value === 'False') {
      const analyteNamesDiff = this.analysisFormGroup.get('analyteNamesDiff') as FormArray;
      analyteNamesDiff.removeAt(index);
    }
  }




  multipleAnalyteValues() {
    const multipleChecked = this.analysisFormGroup.value.multipleAnalytes;
    const count = this.analysisFormGroup.value.analyteNames;

    if (multipleChecked === 'True' && count.length === 1) {

      // tslint:disable-next-line: no-unused-expression
      this.analysisFormGroup.invalid;
    } else {

    }

  }

}
